function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import { Form, Field } from "@xo-union/tk-component-fields";
import { FormBlockColumn } from "@xo-union/tk-component-form-grid";
import { useTrackImpression } from "@xo-union/tk-component-analytics";
import { ModalHeader } from "@xo-union/ui-accessibility";
import { InlineAlert } from "@xo-union/tk-component-alerts";
import { compose } from "@xo-union/react-css-modules";
import mapPropsToAnalyticsData from "./mapPropsToAnalyticsData/index.js";
import FormSubmitButton from "../Buttons/index.js";
import styles from "../../css/index.css";
import generateFormLinks from "../../utils/generateFormLinks/index.js";
var FormHeader = function FormHeader() {
  return /*#__PURE__*/React.createElement(ModalHeader, {
    className: styles.logInHeader
  }, "Log in to The Knot");
};
var FormFooter = function FormFooter(_ref) {
  var onClickSignUp = _ref.onClickSignUp;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styles.footer
  }, "Are you a vendor? \xA0", /*#__PURE__*/React.createElement("a", {
    className: styles.footerLink,
    href: "https://www.theknot.com/vendors/home?itm_source=theknot.com&itm_medium=referral&itm_campaign=log-in-modal"
  }, "Log in here"), /*#__PURE__*/React.createElement("hr", null), "Not a member yet? \xA0", /*#__PURE__*/React.createElement("button", {
    className: styles.footerLink,
    onClick: onClickSignUp,
    type: "button"
  }, "Join now")));
};
process.env.NODE_ENV !== "production" ? FormFooter.propTypes = {
  onClickSignUp: PropTypes.func.isRequired
} : void 0;
var LogInForm = function LogInForm(props) {
  useTrackImpression(mapPropsToAnalyticsData(props));
  var links = generateFormLinks();
  var onClickSignUp = props.onClickSignUp,
    onSubmit = props.onSubmit,
    inProgress = props.inProgress,
    Footer = props.Footer,
    Header = props.Header,
    initialFocusRef = props.initialFocusRef,
    emailProps = props.emailProps,
    passwordProps = props.passwordProps,
    alertProps = props.alertProps;
  var _React$useState = React.useState(''),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    email = _React$useState2[0],
    setEmail = _React$useState2[1];
  var _React$useState3 = React.useState(''),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    password = _React$useState4[0],
    setPassword = _React$useState4[1];
  var handleSubmit = function handleSubmit(evt, originalEvent) {
    var data = {
      email: email,
      password: password
    };
    onSubmit(_objectSpread(_objectSpread({}, evt), {}, {
      data: data
    }), originalEvent);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: styles.formContainer
  }, /*#__PURE__*/React.createElement(Header, null), /*#__PURE__*/React.createElement(InlineAlert, _extends({
    classes: compose({
      container: styles.formAlert
    }),
    type: "error",
    visible: false
  }, alertProps), typeof (alertProps === null || alertProps === void 0 ? void 0 : alertProps.children) === 'function' ? alertProps.children(alertProps.data) : (alertProps === null || alertProps === void 0 ? void 0 : alertProps.data) || 'Something went wrong. Please try again.'), /*#__PURE__*/React.createElement(Form, {
    onSubmit: handleSubmit,
    "aria-busy": inProgress ? 'true' : undefined,
    "aria-label": "log in"
  }, /*#__PURE__*/React.createElement(FormBlockColumn, null, /*#__PURE__*/React.createElement(Field, _extends({
    value: email,
    onChange: function onChange(evt) {
      return setEmail(evt.target.value);
    },
    name: "email",
    type: "email",
    validations: {
      required: true
    },
    ref: initialFocusRef,
    label: "Email address",
    autoComplete: "email"
  }, emailProps))), /*#__PURE__*/React.createElement(FormBlockColumn, null, /*#__PURE__*/React.createElement(Field, _extends({
    value: password,
    onChange: function onChange(evt) {
      return setPassword(evt.target.value);
    },
    validations: {
      required: true
    },
    name: "password",
    type: "password",
    autoComplete: "current-password"
  }, passwordProps))), /*#__PURE__*/React.createElement(FormSubmitButton, {
    isLoading: inProgress
  }, "Log in")), /*#__PURE__*/React.createElement("div", {
    className: styles.formSubText
  }, /*#__PURE__*/React.createElement("a", {
    className: styles.forgotPwd,
    href: links.FORGOT_PASSWORD
  }, "Forgot your password?")), /*#__PURE__*/React.createElement(Footer, {
    onClickSignUp: onClickSignUp
  }));
};
process.env.NODE_ENV !== "production" ? LogInForm.propTypes = {
  /**
   * Evoked when clicking on 'Sign Up'
   */
  onClickSignUp: PropTypes.func.isRequired,
  /**
   * Form submission callback
   */
  onSubmit: PropTypes.func.isRequired,
  /**
   * To indicate that an API is processing
   */
  inProgress: PropTypes.bool,
  /**
   * Footer section component
   */
  Footer: PropTypes.func,
  /**
   * Header section component
   */
  Header: PropTypes.func,
  /**
   * Element to set as the initial focus
   */
  initialFocusRef: PropTypes.shape({
    current: PropTypes.shape()
  }),
  /**
   * Used to set additional props on the email field
   */
  emailProps: PropTypes.shape(),
  /**
   * Used to set additional props on the password field
   */
  passwordProps: PropTypes.shape(),
  /**
   * Used to set additional props on the alert
   */
  alertProps: PropTypes.shape()
} : void 0;
LogInForm.defaultProps = {
  inProgress: false,
  Footer: FormFooter,
  Header: FormHeader,
  emailProps: {},
  passwordProps: {}
};
export default LogInForm;